module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.ade91f47.ttf";